module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-minus-24f09760.svg";